import axios from 'axios';
import jwtService from '../../auth/services/jwtService/jwtService';

const msgpack = require('msgpack-lite');

const getThree = (n) => {
  // eslint-disable-next-line no-restricted-properties
  return n && Math.floor(n / Math.pow(10, Math.floor(Math.log10(n)) - 2));
};

const logMethod = (start, method, params, result) => {
  // eslint-disable-next-line camelcase
  // const req_url = method.split('/api');
  if (localStorage.getItem('LOG')) {
    console.group(
      '%cREQUEST_SERVICE:',
      ' color: white; background-color: #3B82F6; padding: 2px; border-radius: 5px',
      // req_url[0].trim()
      method.trim(),
    );
    console.log(`${getThree((Date.now() - start) / 60)}ms`, method.trim(), params, result);
    console.groupEnd();
  }
};

const logMethodError = (start, method, params, result) => {
  // eslint-disable-next-line camelcase
  // const req_url = method.split('/api');
  if (localStorage.getItem('LOG')) {
    console.group(
      '%cREQUEST_SERVICE_ERROR:',
      ' color: white; background-color: #EB4C42; padding: 2px; border-radius: 5px',
      // req_url[0].trim()
      method.trim(),
    );
    console.log(Date.now() - start, method.trim(), params, result);
    console.groupEnd();
  }
};

const api = () => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_ROOT,
    responseType: 'arraybuffer',
  });

  let requestBody;
  let start;
  instance.interceptors.request.use((req) => {
    const request = {
      ...req,
    };
    // eslint-disable-next-line camelcase
    const access_token = window.localStorage.getItem('access_token');
    request.headers = {
      // eslint-disable-next-line camelcase
      Authorization: `Bearer ${access_token}`,
    };
    requestBody = request.data;
    request.data = msgpack.encode(request.data).buffer;
    start = Date.now();
    return request;
  });

  instance.interceptors.response.use(
    (res) => {
      const response = {
        ...res,
      };
      console.time('request');
      response.data = msgpack.decode(new Uint8Array(response.data));
      console.timeEnd('request');
      logMethod(start, response.config.url, requestBody, response.data);
      return response;
    },
    (error) => {
      console.log(error);
      // error.response.data = msgpack.decode(new Uint8Array(error.response.data));
      // store.dispatch(
      //   showMessage(
      //     error.response.data.message
      //       ? { message: error.response.data.message }
      //       : { message: JSON.stringify(error.response.data) }
      //   )
      // );
      logMethodError(start, error.response.config.url, requestBody, error.message);
      const originalRequest = error.config;
      if (error?.response?.status === 403 && !error.config?._isRetry) {
        originalRequest._isRetry = true;
        localStorage.removeItem('access-token');
        try {
          jwtService
            .signInWithToken()
            .then((user) => {
              console.log(user);
              // localStorage.setItem('user_role', JSON.stringify(user.roles_names));
            })
            .catch((err) => {
              console.log(err);
            });
        } catch (e) {
          console.error('NOT_AUTHORIZED');
        }
      }
      return error;
    },
  );

  return instance;
};

// eslint-disable-next-line import/prefer-default-export
export { api };
